/**
 * Numeros da rede. FONTE UNICA: importado pelo cliente (src/net/*) e pelo
 * servidor (server/net/*). Nao redefina taxa, limite ou tolerancia em lugar
 * nenhum - divergencia entre as duas pontas aqui vira "o servidor recusa tiro
 * legitimo" ou "o boneco remoto anda aos pulos", e isso e cruel de diagnosticar.
 *
 * Este arquivo e PURO: zero import. Roda no browser e no Node sem transpilar.
 */

export const NET = {
  /** Passos de simulacao da sala por segundo (servidor). */
  TICK_RATE: 30,

  /** Snapshots enviados por segundo a cada cliente. */
  SNAPSHOT_RATE: 20,

  /** Estados que o cliente envia por segundo. Igual ao snapshot: 1 para 1. */
  STATE_RATE: 20,

  /**
   * Atraso do buffer de interpolacao, em segundos. O jogador remoto e desenhado
   * SEMPRE neste passado, para que existam dois snapshots cercando o instante
   * desenhado. Menor que isso e o boneco trava a cada perda de pacote; maior e
   * mira em fantasma. 100 ms = 2 snapshots a 20 Hz, com 1 de folga.
   */
  INTERP_DELAY: 0.10,

  /** Alem disso, o remoto e extrapolado por conta propria - e no maximo isto. */
  MAX_EXTRAPOLATION: 0.25,

  /** Sem snapshot ha este tempo, o remoto e considerado sumido e some da tela. */
  REMOTE_TIMEOUT: 5.0,

  /** Intervalo do ping medido pelo servidor. */
  PING_INTERVAL: 3.0,

  /** Conexao sem nenhuma mensagem por este tempo e derrubada pelo servidor. */
  CONNECTION_TIMEOUT: 20.0,

  /** Tentativas de reconexao do cliente e espera entre elas (backoff). */
  RECONNECT_TRIES: 6,
  RECONNECT_BASE_DELAY: 0.6,
  RECONNECT_MAX_DELAY: 8.0,

  /** Tamanho maximo de mensagem aceita do cliente, em bytes. */
  MAX_MESSAGE_BYTES: 8 * 1024,

  /** Mensagens por segundo por conexao antes de o servidor comecar a descartar. */
  MAX_MESSAGES_PER_SEC: 120
};

/** Limites da validacao de plausibilidade (server/net/validate.js). */
export const LIMITS = {
  /**
   * Teto de velocidade horizontal. E a corrida (6.6 m/s) com folga de 60% para
   * absorver latencia irregular, descida de rampa e o sobe-desce do frame.
   * Estourar isso nao bane ninguem: o servidor puxa o jogador de volta.
   */
  MAX_SPEED: 10.6,

  /** Teto de subida por segundo (pulo vale ~6.8 m/s de velocidade inicial). */
  MAX_CLIMB_RATE: 9.0,

  /** Salto de posicao num unico estado que ja e teleporte descarado. */
  MAX_JUMP_DISTANCE: 8.0,

  /** Fora desta caixa o jogador esta fora do mapa - reposicionado no spawn. */
  WORLD_BOUNDS: { minX: -300, maxX: 300, minY: -50, maxY: 200, minZ: -300, maxZ: 300 },

  /**
   * Tolerancia de cadencia: o cliente pode reclamar tiro ate 15% mais rapido que
   * o rpm da arma. Abaixo disso e jitter de rede; acima e macro de tiro.
   */
  FIRE_RATE_TOLERANCE: 0.85,

  /**
   * Folga sobre o alcance da arma ao validar a distancia do acerto. Cobre o
   * deslocamento do alvo entre o frame que o cliente viu e o snapshot que o
   * servidor tem.
   */
  RANGE_TOLERANCE: 1.25,

  /**
   * Quanto o alvo pode ter se afastado, em metros, da posicao que o servidor
   * conhece. E o quanto um jogador correndo anda em INTERP_DELAY + um ping ruim.
   */
  POSITION_TOLERANCE: 4.0,

  /** Acertos por segundo por atirador acima disto e script, nao pontaria. */
  MAX_HITS_PER_SEC: 25
};

/** Regras da partida de deathmatch. */
export const MATCH = {
  MODE: 'deathmatch',
  SCORE_LIMIT: 30,          // baixas para encerrar
  TIME_LIMIT: 600,          // segundos
  MIN_PLAYERS: 1,           // 1 ja permite entrar e esperar
  MAX_PLAYERS: 12,
  RESPAWN_DELAY: 3.0,
  WARMUP: 3.0,              // segundos antes de valer ponto
  SCORE_KILL: 100,
  SCORE_HEADSHOT_BONUS: 50,
  SCORE_DEATH_PENALTY: 0,
  /** Placar completo enviado a cada N segundos (fora dos eventos de baixa). */
  SCORE_BROADCAST: 1.0
};

/** Codigos de erro do protocolo. Cliente traduz para texto na tela. */
export const ERR = {
  BAD_TOKEN: 'bad_token',
  NOT_AUTHENTICATED: 'not_authenticated',
  ROOM_FULL: 'room_full',
  ROOM_NOT_FOUND: 'room_not_found',
  ALREADY_IN_ROOM: 'already_in_room',
  NOT_IN_ROOM: 'not_in_room',
  RATE_LIMITED: 'rate_limited',
  BAD_MESSAGE: 'bad_message',
  SERVER_ERROR: 'server_error'
};

/** Bits do campo `f` (flags) do estado do jogador. */
export const FLAG = {
  CROUCH: 1 << 0,
  ADS: 1 << 1,
  SPRINT: 1 << 2,
  RELOAD: 1 << 3,
  DEAD: 1 << 4,
  GROUNDED: 1 << 5
};
